import { useTranslation } from 'next-i18next'
import corailImpact from 'assets/home-corail-impact.webp'
import ZigZagCheck from 'blocks/ZigZagCheck'
import type { ZigZagCheckItem } from 'blocks/ZigZagCheck'

export function Impact() {
  const { t } = useTranslation('home.page')
  const items: ZigZagCheckItem[] = [
    {
      id: 1,
      description: t('impact.description'),
      title: t('impact.title'),
      image: { image: corailImpact, alt: '' },
      link: {
        url: '/loyalty',
        title: t('impact.link'),
        locale: false,
      },
    },
  ]

  return <ZigZagCheck zigzagcheckItems={items} />
}
